import { render, staticRenderFns } from "./NewSupplierPriceComponent.vue?vue&type=template&id=494f64bc&scoped=true"
import script from "./NewSupplierPriceComponent.vue?vue&type=script&lang=js"
export * from "./NewSupplierPriceComponent.vue?vue&type=script&lang=js"
import style0 from "./NewSupplierPriceComponent.vue?vue&type=style&index=0&id=494f64bc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f64bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('494f64bc')) {
      api.createRecord('494f64bc', component.options)
    } else {
      api.reload('494f64bc', component.options)
    }
    module.hot.accept("./NewSupplierPriceComponent.vue?vue&type=template&id=494f64bc&scoped=true", function () {
      api.rerender('494f64bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/NewSupplierPriceComponent.vue"
export default component.exports